import { getAuthorizationSessionHeader } from 'api/utils/getAuthorizationSessionHeader'
import axios, { AxiosError } from 'axios'
import config from 'config'

import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function getLoggedInUser() {
    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/users/current/`,
            {
                withCredentials: true,
                headers: {
                    Authorization: getAuthorizationSessionHeader(),
                    ...defaultLosJsonHeaders(),
                },
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        throw new Error(axiosError.message)
    }
}
